/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseObject from "@shared/BaseObject.js";
import {ReminderTriggerType} from "@shared/scheduler/reminders/ReminderTriggerType";

const MINUTES_MS = 60 * 1000
const HOURS_MS = 60 * MINUTES_MS
const DAYS_MS = 24 * HOURS_MS

export default class ReminderTriggerItem extends BaseObject{

	triggerShift = -24 * 60 * 60 * 1000
	triggerDeadline = 0

	shiftBaseAmount = 24 // amount
	extraShiftAmountMs = 0 // additional shift amount. Used for example to calculate shift after the end of a session
	shiftUnits = HOURS_MS //represents hours, days, etc in milliseconds
	shiftDirection = ReminderTriggerType.REMINDER //-1 means before event, ie reminder; +1 is after event, ie follow up; 0 means at the time it was created


	constructor(triggerShift = -24 * 60 * 60 * 1000, triggerDeadline = 0) {
		super();
		this.triggerShift = triggerShift;
		this.triggerDeadline = triggerDeadline;
		this.recalculateShiftParams()
	}

	setTriggerTypeImmediate(){
		this.setTriggerType(ReminderTriggerType.IMMEDIATE)
	}
	setTriggerType(type){
		this.shiftDirection = type
	}

	getTriggerTime(targetTime){
		if(targetTime === null || targetTime === undefined){
			targetTime = new Date().getTime()
		}
		return targetTime + this.getTriggerShift()
	}

	getDeadlineTime(targetTime){
		if(targetTime){
			if(this.isReminder()){
				return targetTime + this.triggerDeadline + 24 * 60 * 60 * 1000
			} else if(this.isTriggerWhenCreated()){
				return targetTime + this.triggerDeadline + 24 * 60 * 60 * 1000
			}
		}
		return 0
	}

	recalculateShiftParams(){
		if(this.triggerShift){
			this.shiftUnits = HOURS_MS
			let amount = this.triggerShift / this.shiftUnits
			this.shiftBaseAmount = Math.abs(amount)
			this.shiftDirection = amount / Math.abs(amount)
			this.triggerShift = 0
		} else {
			this.shiftDirection = 0
		}
	}

	getTriggerShift(){
		let shiftDirection = this.shiftDirection// === 0 ? 1 : this.shiftDirection
		return this.shiftBaseAmount * this.shiftUnits * shiftDirection + this.extraShiftAmountMs
	}

	isFollowup(){
		return this.shiftDirection > 0
	}

	isReminder(){
		return this.shiftDirection < 0
	}

	isTriggerWhenCreated(){
		return this.shiftDirection === 0
	}

	// equals(other){
	// 	if(!other){
	// 		console.log("equals: other is null")
	// 		return false
	// 	}
	// 	if(this.triggerShift != other.triggerShift){
	// 		console.log("equals: triggerShift is not equal")
	// 		return false
	// 	}
	// 	if(this.triggerDeadline != other.triggerDeadline){
	// 		console.log("equals: triggerDeadline is not equal")
	// 		return false
	// 	}
	//
	// 	return true
	// }
}
